import style from './Loader.module.scss';
interface LoaderProps {
  loadingText?: string;
}
export default function Loader({
  loadingText
}: LoaderProps) {
  return <div id="loader" className={style.root} data-sentry-component="Loader" data-sentry-source-file="Loader.tsx">
			<div data-testid="loader" className={style.loader}></div>
			{loadingText && <p className={style.loadingText}>{loadingText}</p>}
		</div>;
}